import React from "react"
import { navigate } from "vike/client/router"
import Modal from "aldoo-ra/Modal"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import TextBundle from "aldoo-ra/CMS/text-bundle"

const ManageSubscriptionDialog = ({
  isOpen,
  onClose,
  onCancel,
  subscription,
}) => {
  const handleChangePlan = () => {
    navigate("/pricing")
  }

  const texts = TextBundle({ id: "manage_subscription_dialog" })

  return (
    <Modal
      title={texts?.title}
      isOpen={isOpen}
      onClose={onClose}
      variant="aqua_medium"
      className="md:max-w-[500px]"
    >
      <div className="max-w-[500px] space-y-6 md:space-y-10 pt-14 md:pt-6 pb-6 md:pb-0 mx-auto md:mx-0">
        {/* First card */}
        <div
          onClick={handleChangePlan}
          className="flex items-center justify-between gap-2 rounded-[24px] shadow-custom_card hover:bg-primary_lt cursor-pointer px-6 md:px-8 py-8"
        >
          <Typography variant="info_18" className="my-0">
            {texts?.change_plan_text}
          </Typography>

          <Button variant="secondary_s" className="min-w-[90px]">
            {texts?.change_plan_button}
          </Button>
        </div>

        {/* Second card */}
        {subscription.status !== "canceled" && (
          <div
            onClick={onCancel}
            className="flex items-center justify-between gap-2 rounded-[24px] shadow-custom_card hover:bg-primary_lt cursor-pointer px-6 md:px-8 py-8"
          >
            <Typography variant="info_18" className="my-0">
              {texts?.cancel_sub_text}
            </Typography>

            <Button variant="secondary_s" className="min-w-[90px]">
              {texts?.cancel_button}
            </Button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default ManageSubscriptionDialog
